G.PopUpFlexBg = function () {
  Phaser.Group.call(this, game);

  const textures = this._doTextures();

  this.pivot.y = 333;
  this.bottomBg = G.makeImage(0, 666, textures.bottom, [0.5, 1], this);
  this.topBg = G.makeImage(0, 0, textures.top, [0.5, 0], this);
};

G.PopUpFlexBg.prototype = Object.create(Phaser.Group.prototype);

G.PopUpFlexBg.prototype.changeSize = function (newY, skipAnim) {
  newY = Math.max(70, newY);
  game.tweens.removeFrom(this.bottomBg);
  if (skipAnim) {
    this.bottomBg.y = newY + 333;
    this.bottomBg.height = Math.max(G.OMTsettings.global.popUpFlexBg.bottomBgHeight, newY);
  } else {
    game.add.tween(this.bottomBg)
      .to({ y: newY + 333, height: Math.max(333, newY) }, 300, Phaser.Easing.Sinusoidal.Out, true);
  }
};

G.PopUpFlexBg.prototype._doTextures = function () {
  const marker = G.makeImage(0, 0, 'popup_background_2', 0);
  const top = game.make.renderTexture(G.OMTsettings.global.popUpFlexBg.width, 333);
  top.renderXY(marker, 0, 0);
  const bottom = game.make.renderTexture(G.OMTsettings.global.popUpFlexBg.width, 333);
  bottom.renderXY(marker, 0, -333);
  marker.destroy();
  G.PopUpFlexBg.texturesInitialized = true;

  this.onDestroy.add(function () {
    top.destroy(true);
    bottom.destroy(true);
  });

  return {
    top,
    bottom,
  };
};
